import React from "react";
import "./css/Policy.css";

const Policy = () => {
  return (
    <>
      <div className="container mb-5">
        <h2 style={{ textAlign: "center" }}>Privacy Policy — InstaPe Synergies Pvt Ltd</h2>
      
        <p style={{ textAlign: "justify" }}>
          This Privacy Policy explains how Instape Synergies Pvt Ltd (“We”, “Us”, “Our”) collects, uses, stores, discloses and protects personal information when you use the InstaPe App (“Application”), which facilitates access to salary advance and related financial services provided by RBI-regulated lending partners.
        </p>
        
        <p style={{ textAlign: "justify" }}>
          This Policy is governed by applicable Indian laws including the Information Technology Act, 2000 and rules there under, RBI guidelines, and other relevant regulations.
        </p>

        <ol className="nested-list">
          <li>
            <b>CONSENT</b>
            <ol style={{ marginTop: 10 }}>
              <li>
                By using the Application, you expressly agree to the collection, use, retention, and disclosure of your information as described in this Privacy Policy.
              </li>
            </ol>
          </li>

          <li>
            <b>INFORMATION WE COLLECT</b>
            <ol>
              <li>
                We collect the following categories of personal information:
                <ol className="alpha-nested">
                  <li>
                    <b>Identity & Contact Data</b><br />
                    Name<br />
                    Mobile number<br />
                    Email address<br />
                    Date of birth<br />
                    Address (permanent/temporary)
                  </li>
                  <li>
                    <b>Employment & Financial Data</b><br />
                    Employer's name and employee ID<br />
                    Salary details (where required for processing)<br />
                    Other employment information necessary for eligibility
                  </li>
                  <li>
                    <b>KYC & Verification</b><br />
                    We collect data required by regulated lenders to complete KYC/identity verification, which may include:<br />
                    Selfie image<br />
                    Camera access for document capture<br /><br />
                    Approximate location (ACCESS_COARSE_LOCATION) is used only to embed geolocation on KYC photographs as required by the lending partner. We do not collect background location or use location for tracking.
                  </li>
                  <li>
                    <b>App Usage Data</b><br />
                    We may collect:<br />
                    Screen interactions<br />
                    Dates/times of use<br />
                    Pages viewed
                  </li>
                </ol>
              </li>
            </ol>
          </li>

          <li>
            <b>HOW WE USE YOUR INFORMATION</b>
            <ol>
              <li>
                We use collected data to:
                <ol className="bullet-nested">
                  <li>Establish and verify identity</li>
                  <li>Facilitate KYC as required by lenders</li>
                  <li>Administer and improve the Application</li>
                  <li>Provide services requested by you</li>
                  <li>Send communications regarding service updates</li>
                  <li>Comply with legal/regulatory requirements</li>
                  <li>Detect and prevent fraud</li>
                </ol>
              </li>
              <li>
                We may also use aggregated data for analytics and service improvement.
              </li>
            </ol>
          </li>

          <li>
            <b>DATA DISCLOSURE & SHARING</b>
            <ol>
              <li>
                We may share your information with:
                <ol className="bullet-nested">
                  <li>Regulated lending partners to enable loan facilitation</li>
                  <li>Third-party service providers who support KYC, identity verification, analytics, and technical operations</li>
                  <li>Regulatory authorities to comply with law or court orders</li>
                  <li>Legal authorities to detect or prevent fraud or illegal activity</li>
                </ol>
              </li>
              <li>
                We do not share your personal data for advertising or marketing to unrelated third parties without your consent.
              </li>
            </ol>
          </li>

          <li>
            <b>DATA STORAGE & RETENTION</b>
            <ol>
              <li>
                Your data is stored securely on servers located in India and retained only as long as necessary for service delivery, compliance, or legal reporting.
              </li>
              <li>
                You have the right to request deletion of your personal data. However, deletion may impact the ability to provide continued services.
              </li>
            </ol>
          </li>

          <li>
            <b>YOUR RIGHTS</b>
            <ol>
              <li>
                You can:
                <ol className="bullet-nested">
                  <li>Modify permissions on your device</li>
                  <li>Request correction or deletion of your personal data</li>
                  <li>Withdraw consent at any time (subject to service limitations)</li>
                </ol>
              </li>
            </ol>
          </li>

          <li>
            <b>SECURITY PRACTICES</b>
            <ol>
              <li>
                We implement appropriate technical and organizational measures to safeguard your information including encryption and strict access controls.
              </li>
            </ol>
          </li>

          <li>
            <b>CHANGES TO POLICY</b>
            <ol>
              <li>
                We may update this Privacy Policy to reflect changes in laws, regulations, or our operations. We encourage periodic review.
              </li>
            </ol>
          </li>

          <li>
            <b>CONTACT</b>
            <ol>
              <li>
                For privacy inquiries, contact us at:<br />
                Email: support@instape.com<br />
                Address: InstaPe Synergies Pvt Ltd (Registered Office)
              </li>
            </ol>
          </li>

          <li>
            <b>APP PERMISSIONS USED</b>
            <ol>
              <li>
                The InstaPe Application requests only those permissions necessary to provide regulated financial services in compliance with applicable laws and RBI guidelines. The permissions requested and their purpose are described below:
                
                <ol style={{ marginTop: "15px" }}>
                  <li>
                    <b> android.permission.INTERNET</b><br />
                    Used to enable secure communication between the Application and our servers and regulated lending partners for service delivery, authentication, and transaction processing.
                  </li>
                  <li>
                    <b> android.permission.CAMERA</b><br />
                    Used to capture borrower selfies and supporting documents as part of the KYC process required by regulated lending partners.
                  </li>
                  <li>
                    <b> android.permission.VIBRATE</b><br />
                    Used to provide device vibration feedback for user notifications and in-app alerts.
                  </li>
                  <li>
                    <b> android.permission.ACCESS_COARSE_LOCATION</b><br />
                    Used only to obtain approximate location for embedding geolocation on KYC photographs where required by lending partners. The Application does not collect background location data or use location for tracking purposes.
                  </li>
                  <li>
                    <b> android.permission.RECORD_AUDIO</b><br />
                    May be used during KYC-related interactions or lender-facilitated verification processes where microphone access is required. The Application does not record or store audio beyond what is necessary for such regulated verification processes.
                  </li>
                  <li>
                    <b> android.permission.MODIFY_AUDIO_SETTINGS</b><br />
                    Used to manage audio settings during microphone-enabled interactions within the Application, if applicable. The Application does not access stored audio files or monitor calls.
                  </li>
                  <li>
                    <b> android.permission.POST_NOTIFICATIONS</b><br />
                    Used to send users service-related notifications such as application status updates, repayment reminders, and important account communications.
                  </li>
                  <li>
                    <b> com.google.android.gms.permission.AD_ID</b><br />
                    Used to enable Google Play Services functionality, including analytics and service performance monitoring. The Application does not use this permission for profiling or unauthorized advertising purposes.
                  </li>
                  <li>
                    <b> android.permission.USE_BIOMETRIC</b><br />
                    Used to enable secure device-level biometric authentication (such as fingerprint or face authentication) for login and access to the Application. The Application does not collect, store, or process biometric data. Authentication is performed securely by the device operating system.
                  </li>
                  <li>
                    <b> android.permission.USE_FINGERPRINT</b><br />
                    Used to support fingerprint-based authentication on compatible Android devices. InstaPe does not receive or store fingerprint data. Biometric authentication is handled by the device's secure hardware and operating system.
                  </li>
                </ol>
              </li>
            </ol>
          </li>

          <li>
            <b>LENDING PARTNERS (DATA SHARING)</b>
            <ol>
              <li>
                As part of providing services, your information may be shared with:
                <ol className="bullet-nested">
                  <li>Suryoday Small Finance Bank Limited</li>
                  <li>Mufin Green Finance Limited</li>
                </ol>
              </li>
              <li>
                These lenders are RBI-regulated entities disbursing loans via the InstaPe platform.
              </li>
            </ol>
          </li>
        </ol>
      </div>
    </>
  );
};

export default Policy;